import { IUser } from "@/api";
import { createContext } from "react";

let currentAuthSessionEpoch = 0;

/**
 * Module state, not React state: a run that captured an epoch must still be
 * able to read the current one after the authenticated subtree has unmounted,
 * which is exactly what logout does.
 */
export function getAuthSessionEpoch(): number {
    return currentAuthSessionEpoch;
}

/** Monotonic for the lifetime of the tab; an earlier epoch never matches again. */
export function advanceAuthSessionEpoch(): number {
    currentAuthSessionEpoch += 1;
    return currentAuthSessionEpoch;
}

export type AuthContextType = {
    authenticated: boolean;
    session: {
        create: (token: string, refresh_token: string) => void;
        end: () => void;
        refresh: () => void;
    };
    user: IUser | null;
};

export const AuthContext = createContext<AuthContextType>({
    authenticated: false,
    session: {
        create: () => {},
        end: () => {},
        refresh: () => {},
    },
    user: null,
});
